export const integerRange = (from: number, to: number) => {
  return Array.from(Array(to - from + 1), (_, i) => i + from);
};
